import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {useOrganization} from "../hooks/useOrganization.ts";


export const EditFormDrawer = (props: DrawerProps) => {

    const {id: organizationId} = useParams();

    if (typeof organizationId === 'undefined') {
        throw new Error('organizationId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = useOrganization(organizationId);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
